import { render } from "./taskInfo.vue?vue&type=template&id=3035c66c&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=ts"
export * from "./taskInfo.vue?vue&type=script&lang=ts"

import "./taskInfo.vue?vue&type=style&index=0&id=3035c66c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3035c66c"

export default script